import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { CurrentUserService } from './core/services/current-user.service';
import { AuthService } from './core/services/auth.service';
import { PrimeNgModule } from './prime-ng.module';
import { SentryContextService } from './core/services/sentry-context.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ButtonDirective,
    Ripple,
    CoreModule,
    SharedModule,
    PrimeNgModule,
  ],
  providers: [CurrentUserService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(
    private currentUserService: CurrentUserService,
    private authService: AuthService,
    private sentryContextService: SentryContextService
  ) {}
}
